module.exports = __webpack_public_path__ + "media/application/images/icons/plus-white-86714cf9d45a29a5b9f091bc67830be2.svg";